<template>
    <div class="detail" v-if="currentClock">
        <div class="detail-wrapper">
            <h3 class="detail-title">Intro</h3>

            <div class="detail-row detail-row--2cols">
                <div class="detail-cell">
                    <span class="detail-label">Intro Box</span>
                    <div class="field">
                        <select v-model="brandingForm.introBoxUid" class="select" name="introBoxUid">
                            <option :value="null">-- none --</option>
                            <option
                                v-for="box in jingleBoxes"
                                :key="box.uid"
                                :value="box.uid">{{ box.name }}</option>
                        </select>
                    </div>
                    <div
                        v-if="Object.keys(errors).includes('branding.introBoxUid')"
                        class="error message">
                        {{ errors['branding.introBoxUid'].join(' ') }}
                    </div>
                </div>
                <div v-if="brandingForm.introBoxUid" class="detail-cell">
                    <span class="detail-label">Intro File</span>
                    <div class="field">
                        <select v-model="brandingForm.introTrackUid" class="select" name="introTrackUid">
                            <option :value="null">Select an Intro File</option>
                            <option
                                v-for="track in introBoxTracks"
                                :key="track.uid"
                                :value="track.uid">{{ track.artist }} - {{ track.title }}</option>
                        </select>
                    </div>
                    <div
                        v-if="Object.keys(errors).includes('branding.introTrackUid')"
                        class="error message">
                        {{ errors['branding.introTrackUid'].join(' ') }}
                    </div>
                </div>
            </div>

            <h3 class="detail-title">Extro</h3>

            <div class="detail-row detail-row--2cols">
                <div class="detail-cell">
                    <span class="detail-label">Extro Box</span>
                    <div class="field">
                        <select v-model="brandingForm.extroBoxUid" class="select" name="extroBoxUid">
                            <option :value="null">-- none --</option>
                            <option
                                v-for="box in jingleBoxes"
                                :key="box.uid"
                                :value="box.uid">{{ box.name }}</option>
                        </select>
                    </div>
                    <div
                        v-if="Object.keys(errors).includes('branding.extroBoxUid')"
                        class="error message">
                        {{ errors['branding.extroBoxUid'].join(' ') }}
                    </div>
                </div>
                <div v-if="brandingForm.extroBoxUid" class="detail-cell">
                    <span class="detail-label">Extro File</span>
                    <div class="field">
                        <select v-model="brandingForm.extroTrackUid" class="select" name="extroTrackUid">
                            <option :value="null">Select an Extro File</option>
                            <option
                                v-for="track in extroBoxTracks"
                                :key="track.uid"
                                :value="track.uid">{{ track.artist }} - {{ track.title }}</option>
                        </select>
                    </div>
                    <div
                        v-if="Object.keys(errors).includes('branding.extroTrackUid')"
                        class="error message">
                        {{ errors['branding.extroTrackUid'].join(' ') }}
                    </div>
                </div>
            </div>

            <div class="detail-footer">
                <div class="detail-footer-right">
                    <div v-if="viewState.isUpdatingBox" class="detail-footer-loader">Saving...</div>
                    <button class="detail-save" :disabled="viewState.isUpdatingBox" v-on:click="onSave">Save</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Apis from '@/apis'
    import { HTTP } from '@/utils/http'
    import {mapState} from "vuex";

    export default {
        computed: {
            ...mapState({
                currentClock: state => state.currentClock,
                currentStationUid: state => state.currentStationUid,
                jingleBoxes: (state) => {
                    if (! state.stationBoxes || ! state.stationBoxes.items) {
                        return []
                    }

                    return state.stationBoxes.items.filter(box => box.trackType === 'JINGLE')
                }
            })
        },
        data() {
            return {
                brandingForm: null,
                errors: {},
                extroBoxTracks: [],
                introBoxTracks: [],
                viewState: {
                    isUpdatingClock: false
                }
            }
        },
        methods: {
            async onSave () {
                this.errors = {}
                this.viewState.isUpdatingClock = true

                const boxData = {
                    ...this.currentClock,
                    branding: {
                        extroBoxUid: this.brandingForm.extroBoxUid,
                        extroTrackUid: this.brandingForm.extroBoxUid ? this.brandingForm.extroTrackUid : null,
                        introBoxUid: this.brandingForm.introBoxUid,
                        introTrackUid: this.brandingForm.introBoxUid ? this.brandingForm.introTrackUid : null
                    }
                }

                HTTP.post(Apis.clocks.edit, boxData)
                    .then(response => {
                        this.$store.dispatch("loadClock", {
                            stationUid: this.currentStationUid,
                            clockUid: this.currentClock.uid
                        });
                        if(response.data.isSuccess){
                            this.$store.dispatch('Toasts/addToast', {
                                title: 'Success',
                                message: 'Branding successfully updated',
                                delay: 1500,
                                type: 'success'
                            });
                        }
                    }, error => {
                        if (error.response && error.response.data) {
                            this.errors = error.response.data
                        }
                    })
                    .then(() => {
                        this.viewState.isUpdatingClock = false
                    })
            },

            async loadBoxTracks (boxUid, field) {
                this[field] = []

                if (boxUid === null) {
                    return
                }

                HTTP.get(Apis.boxes.trackList, {
                    params: {
                        stationUid: this.currentStationUid,
                        boxUid
                    }})
                    .then(({ data }) => {
                        this[field] = data.dataItem
                    })
                    .catch(error => {
                        // Add an error
                        console.log('error', error)
                    })
            }
        },
        watch: {
            'currentClock.branding': {
                handler (value) {
                    this.brandingForm = {
                        extroBoxUid: value && value.extroBox ? value.extroBox.uid : null,
                        extroTrackUid: value && value.extroTrack ? value.extroTrack.uid : null,
                        introBoxUid: value && value.introBox ? value.introBox.uid : null,
                        introTrackUid: value && value.introTrack ? value.introTrack.uid : null
                    }
                },
                immediate: true
            },
            'brandingForm.extroBoxUid': {
                handler (value) {
                    this.loadBoxTracks(value, 'extroBoxTracks')
                },
                immediate: true
            },
            'brandingForm.introBoxUid': {
                handler (value) {
                    this.loadBoxTracks(value, 'introBoxTracks')
                },
                immediate: true
            }
        }
    }
</script>
<style lang="scss" scoped>
    .detail {
        padding: 25px 25px 40px;
    }

    .detail-wrapper {
        display: flex;
        flex-direction: column;
        max-width: 840px;
    }

    .detail-title {
        color: #292C33;
        font-size: 16px;
        line-height: 1;

        &:not(:first-child) {
            margin-top: 40px;
        }

        + .detail-row {
            margin-top: 20px;
        }
    }

    .detail-row {
        display: flex;
        margin: 40px -15px 0;

        &:first-child {
            margin-top: 0;
        }

        &--2cols {
            .detail-cell {
                width: 50%;
            }
        }

        &--3cols {
            .detail-cell {
                width: 33.33%;

                &--big {
                    width: 66.66%;
                }
            }
        }
    }

    .detail-cell {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        padding: 0 15px;

        &.has-error {
            .detail-error {
                display: block;
            }
        }
    }

    .detail-label {
        display: block;
        transition: transform .3s ease-in-out;
        color: #696B70;
        font-size: 13px;
        font-weight: 400;
        letter-spacing: .2px;
        line-height: calc(16 / 13);

        i {
            margin-left: 5px;
            color: #ABACAF;
            font-style: italic;
        }
    }

    .detail-value {
        margin-top: 8px;
        display: block;
        color: #292C33;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: .2px;
        line-height: calc(17 / 14);
    }

    .detail-error {
        display: none;
        margin-top: 8px;
        font-size: 14px;
        font-weight: 400;
        line-height: 1;
        color: #f00;
    }

    // Footer
    // -----------------------------------------------------------------------------
    .detail-footer {
        display: flex;
        justify-content: space-between;
        flex-shrink: 0;
        position: relative;
        width: 100%;
        margin-top: 20px;
        padding-top: 25px;
        border-top: 1px solid #d2d2d2;

        button {
            text-transform: uppercase;
        }
    }

    .detail-footer-right {
        display: flex;
        align-items: center;
        margin-left: auto;

        .m-loader + .detail-button {
            opacity: .5;
            pointer-events: none;
        }

        .detail-button {
            margin-left: 20px;
        }
    }

    .detail-footer-loader {
        color: #696B70;
        font-size: 14px;
        margin-right: 10px;
    }

    .detail-link {
        padding: 0;
        border: 0;
        border-radius: 0;
        transition: color .2s ease-in-out;
        background-color: transparent;
        color: #ABACAF;
    }

    // Transitions
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    // Inputs
    .field {
        color: #696B70;
        display: flex;
        flex-direction: column;
        // padding-top: 3px;
        position: relative;
        width: 100%;

        &.inline {
            height: 24px;
            padding-top: 0;
            line-height: 16px;

            .input {
                height: 24px;
            }

            input {
                font-size: 13px;
            }

        }
    }

    .append, .prepend {
        font-size: 13px;
    }

    label {
        display: block;
        font-weight: 300;
        font-size: 11px;
        transition: all .15s ease-out;
        margin-bottom: 0;

        span {
            color: #ABACAF;
            font-style: italic;
        }
    }

    .field.error {
        label {
            color: #FE6B5B;
        }

        .message {
            color: #FE6B5B;
        }
    }

    .message {
        text-align: right;
        font-size: 13px;
        line-height: 20px;
    }

    .select {
        display: flex;
        flex-direction: row;
        align-items: center;
        line-height: 24px;
        background: transparent !important;
        width: 100%;
        outline: 0;
        font-size: 13px;
        height: 32px;
        color: #292C33;
        font-weight: 400;

        &::placeholder {
            color: #ccc;
        }
    }

    .focused:not(.readonly) {
        &:not(.empty) {
            label {
                color: var(--color-brand);
            }
        }
    }

    .error {
        color: #FE6B5B;
    }
</style>